import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../media/logo.png';

const propTypes = {
	location: PropTypes.object,
};

class Navbar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			navBarOpen: false,
		};
	}

	componentWillReceiveProps() {
		this.setState({ navBarOpen: false });
	}

	isPathActive(pathPattern) {
		let isActive = false;

		if (typeof pathPattern === 'string') {
			isActive = this.props.location.pathname === pathPattern;
		} else {
			isActive = this.props.location.pathname.match(pathPattern);
		}

		return ClassNames({
			active: isActive,
		});
	}

	toggleMenu() {
		this.setState({ navBarOpen: !this.state.navBarOpen });
	}

	render() {
		const navBarCollapse = ClassNames({
			'navbar-collapse': true,
			collapse: !this.state.navBarOpen,
		});

		return (
			<div className="navbar navbar-default navbar-fixed-top">
				<div className="container">
					<div className="navbar-header">
						<Link className="navbar-brand" to="/login">
							<img className="navbar-logo" src={logo} alt="BlueTrace" />
						</Link>
						<button
							className="navbar-toggle collapsed"
							onClick={this.toggleMenu.bind(this)}
						>
							<span className="icon-bar" />
							<span className="icon-bar" />
							<span className="icon-bar" />
						</button>
					</div>
					<div className={navBarCollapse}>
						<ul className="nav navbar-nav navbar-right">
							<li className={this.isPathActive(/^\/login/)}>
								<Link to="/login">
									<i className="fa fa-user" /> Sign in
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

Navbar.propTypes = propTypes;

export default Navbar;
